export default __webpack_public_path__ + "static/media/shockblast.77b286de.png";